module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/tr-hover.b9072325.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/tr-hover.png
// module id = 2764
// module chunks = 11